import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { selectAllVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { uploadImages as photoPrintsUploadImages } from '@ff-scene-plugins/photo-prints-pdp/thunks/uploadImages';
import { uploadImage as giftUploadImage } from '@gift-variable-plugins/photo-pdp/partials/helpers/uploadImage';
import { FetchError } from './fetchAllAsFiles';

export const dispatchImages = (
    store: PdpStore,
    files: File[]
): FetchError[] => {
    if (files.length === 0) {
        return [];
    }

    const state = store.getState() as any;
    const pluginId: string = state.scene?.pluginId ?? 'none';

    if (pluginId === 'gift') {
        return dispatchToGift(store, files);
    }
    if (pluginId === 'photo-prints') {
        return dispatchToPhotoPrints(store, files);
    }

    const message = `No upload target: unknown scene plugin '${pluginId}'`;
    return files.map(f => ({ url: f.name, message }));
};

const dispatchToGift = (store: PdpStore, files: File[]): FetchError[] => {
    const state = store.getState() as any;
    const photoVariableIds: string[] = selectAllVariables(state)
        .filter((v: any) => v?.pluginId === 'photo')
        .map((v: any) => v.id);

    if (photoVariableIds.length === 0) {
        const message = 'No photo variables in gift project';
        return files.map(f => ({ url: f.name, message }));
    }

    files.forEach((file, i) => {
        const variableId = photoVariableIds[i % photoVariableIds.length];
        store.dispatch(giftUploadImage(file, variableId) as any);
    });
    return [];
};

const dispatchToPhotoPrints = (store: PdpStore, files: File[]): FetchError[] => {
    const state = store.getState() as any;
    const groupIds: string[] = state.project?.groups?.ids ?? [];
    const groupId = groupIds[0];

    if (!groupId) {
        const message = 'No groups in photo-prints project';
        return files.map(f => ({ url: f.name, message }));
    }

    store.dispatch(photoPrintsUploadImages(files, groupId) as any);
    return [];
};